import { useOnlyFansCreators } from "@/common/hooks/useOnlyFansCreators";
import { AdCreator } from "../AdCreator";
import "./OnlyFansCreatorsSidebar.scss";
import LoaderIcon from "./images/fans-loader.svg?react";
import React from "react";

export const OnlyFansCreatorsSidebar = () => {
  const { adCreators, isLoading } = useOnlyFansCreators("sidebar");

  if (isLoading) {
    return <LoaderIcon />;
  }

  return (
    <div className="OnlyFansCreatorsSidebar">
      <h3 className="title">Onlyfans creators you might enjoy:</h3>
      <div className="list">
        {adCreators.map((adCreator, index) => (
          <React.Fragment key={adCreator.extra.id}>
            <AdCreator
              name={adCreator.extra.name}
              link={adCreator.link}
              image={adCreator.extra.imgUrl}
            />
            {index < adCreators.length - 1 && <hr />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
